module.exports = {
      id: "apple-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#apple",
      toString: function () {
        return this.url;
      }
    }